import React from 'react';
import ComprehensiveSalesScoreboard from './ComprehensiveSalesScoreboard';

export default function SalesLeaderScoreboardPage({ user, managedOwner }) {
  return <ComprehensiveSalesScoreboard user={user} managedOwner={managedOwner} />;
}
